import React, { ComponentType, FC } from 'react';

import { ProtectedOrderStep } from 'src/components/protected-order-step-route';
import { OrderStep } from 'src/state/order/types';

export const withOrderStep =
  <T extends object>(orderStep: OrderStep): ((Component: ComponentType<T>) => FC<T>) =>
  (Component: ComponentType<T>): FC<T> =>
    Object.assign((props: T) => <ProtectedOrderStep orderStep={orderStep} children={<Component {...props} />} />, {
      displayName: 'orderStep',
    });
